<div
  class="min-h-screen overflow-x-hidden bg-gradient-to-br from-slate-50 via-white to-slate-100 text-slate-900 lg:h-screen lg:overflow-y-auto"
>
  <section
    class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:flex lg:h-full lg:min-h-0 lg:flex-col lg:px-8 lg:py-4 lg:pb-16"
  >
    <header class="flex shrink-0 items-center justify-between py-4 lg:py-2">
      <a routerLink="/" class="flex shrink-0 items-center gap-3 rounded-2xl outline-none ring-green-500/40 focus-visible:ring-2">
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-green-500 text-lg font-bold text-white shadow-sm"
          aria-hidden="true"
        >
          W
        </div>
        <div class="hidden sm:block">
          <p class="text-sm font-medium text-slate-500">{{ t("appSubtitle") }}</p>
          <p class="text-lg font-semibold">{{ t("appTitle") }}</p>
        </div>
        <p class="text-lg font-semibold sm:hidden">{{ t("appSubtitle") }}</p>
      </a>
      <div class="flex items-center gap-2">
        <div class="relative">
          <select
            [ngModel]="lang()"
            (ngModelChange)="setLang($event)"
            class="appearance-none rounded-2xl border border-slate-200 bg-white pl-3 pr-7 py-2 text-sm font-semibold shadow-sm transition hover:shadow cursor-pointer outline-none focus:ring-2 focus:ring-green-500/40"
            aria-label="Idioma"
          >
            <option value="pt">PT</option>
            <option value="en">EN</option>
            <option value="es">ES</option>
          </select>
          <svg class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <button
          type="button"
          (click)="openHowItWorks()"
          class="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium shadow-sm transition hover:shadow"
          [attr.aria-label]="t('howItWorks')"
        >
          <span class="hidden sm:inline">{{ t("howItWorks") }}</span>
          <svg class="h-5 w-5 sm:hidden" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 16v-4m0-4h.01"/>
          </svg>
        </button>
      </div>
    </header>

    <main class="py-6 sm:py-10 lg:flex lg:flex-1 lg:items-center lg:py-4">
      <div class="grid w-full grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start lg:gap-12">
        <div class="order-2 mx-auto w-full max-w-xl lg:order-1 lg:mx-0">
          <div class="flex justify-center sm:justify-start">
            <span
              class="inline-flex rounded-full border border-green-200 bg-green-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-green-700"
            >
              {{ t("badge") }}
            </span>
          </div>

          <h1 class="mt-5 text-center text-3xl font-bold leading-tight tracking-tight sm:text-left sm:text-4xl lg:text-5xl">
            {{ t("seoH1") }}
          </h1>
          <h2 class="mt-4 text-center text-xl font-semibold leading-snug text-slate-800 sm:text-left sm:text-2xl lg:text-3xl">
            {{ t("hero") }}
          </h2>

          <p class="mt-5 text-center text-base leading-7 text-slate-600 sm:text-left sm:text-lg">
            {{ t("heroBody") }}
          </p>

          <div class="mt-8 grid grid-cols-3 gap-2 sm:gap-4">
            <div class="rounded-3xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
              <p class="text-2xl font-bold">{{ t("step1Title") }}</p>
              <p class="mt-2 text-sm text-slate-600">{{ t("step1Body") }}</p>
            </div>
            <div class="rounded-3xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
              <p class="text-2xl font-bold">{{ t("step2Title") }}</p>
              <p class="mt-2 text-sm text-slate-600">{{ t("step2Body") }}</p>
            </div>
            <div class="rounded-3xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
              <p class="text-2xl font-bold">{{ t("step3Title") }}</p>
              <p class="mt-2 text-sm text-slate-600">{{ t("step3Body") }}</p>
            </div>
          </div>
          @if (adsenseSlot) {
            <ins
              class="adsbygoogle mt-6 block w-full max-w-full overflow-hidden rounded-2xl"
              style="display: block; width: 100%; max-width: 100%"
              [attr.data-ad-client]="adsenseClient"
              [attr.data-ad-slot]="adsenseSlot"
              data-ad-format="auto"
              data-full-width-responsive="true"
            ></ins>
          }
        </div>

        <div class="order-1 flex min-w-0 justify-center lg:order-2 lg:justify-end w-full">
          <div class="w-full max-w-md">
            <div class="rounded-[2rem] bg-white p-5 shadow-xl ring-1 ring-slate-200 sm:p-6">
              <div class="mb-6 flex items-center justify-between">
                <div>
                  <p class="text-sm text-slate-500">{{ t("cardKicker") }}</p>
                  <h3 class="text-xl font-semibold">{{ t("cardTitle") }}</h3>
                </div>
              </div>

              <form class="space-y-4" (submit)="$event.preventDefault(); openWhatsApp()">
                <div>
                  <label class="mb-2 block text-sm font-medium text-slate-700">
                    {{ t("fullNumber") }}
                  </label>
                  <div class="grid grid-cols-[90px,1fr] gap-3 sm:grid-cols-[140px,1fr]">
                    <div class="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 shadow-inner">
                      <div class="flex items-center gap-2">
                        <span class="text-sm font-semibold text-slate-500">+</span>
                        <input
                          type="tel"
                          inputmode="numeric"
                          autocomplete="tel-country-code"
                          [placeholder]="t('countryCodePlaceholder')"
                          class="w-full bg-transparent text-base outline-none placeholder:text-slate-400"
                          [ngModel]="countryCode()"
                          (ngModelChange)="onCountryCodeInput($event)"
                          name="countryCode"
                          [attr.aria-label]="t('countryCode')"
                        />
                      </div>
                    </div>

                    <div class="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 shadow-inner">
                      <input
                        type="tel"
                        inputmode="numeric"
                        autocomplete="tel-national"
                        [placeholder]="t('phonePlaceholder')"
                        class="w-full bg-transparent text-base outline-none placeholder:text-slate-400"
                        [ngModel]="phoneNumber()"
                        (ngModelChange)="onPhoneNumberInput($event)"
                        name="phoneNumber"
                        [attr.aria-label]="t('phoneNumber')"
                      />
                    </div>
                  </div>
                  <p class="mt-2 text-xs text-slate-500">
                    {{ t("fullNumberHint") }}
                  </p>
                  <p
                    class="mt-2 text-xs font-medium text-red-600"
                    [class.hidden]="!errorMessage()"
                  >
                    {{ errorMessage() }}
                  </p>
                </div>

                <div>
                  <label class="mb-2 block text-sm font-medium text-slate-700">
                    {{ t("presetMessage") }}
                  </label>
                  <div class="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 shadow-inner">
                    <textarea
                      rows="3"
                      [placeholder]="t('presetMessagePlaceholder')"
                      class="w-full resize-none bg-transparent text-base outline-none placeholder:text-slate-400"
                      [ngModel]="presetMessage()"
                      (ngModelChange)="onPresetMessageInput($event)"
                      name="presetMessage"
                    ></textarea>
                  </div>
                </div>

                <button
                  type="submit"
                  class="w-full rounded-2xl bg-green-500 px-5 py-3.5 text-base font-semibold text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl disabled:cursor-not-allowed disabled:bg-green-300 disabled:shadow-none disabled:hover:translate-y-0"
                  [disabled]="!canAct()"
                >
                  {{ t("openWhatsApp") }}
                </button>
              </form>

              <div class="mt-5 rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-4">
                <div class="flex items-start justify-between gap-4">
                  <div class="min-w-0">
                    <p class="text-xs font-semibold uppercase tracking-wide text-slate-500">
                      {{ t("previewLink") }}
                    </p>
                    <p class="mt-2 break-all text-sm text-slate-700">{{ previewLink() }}</p>
                  </div>
                  <div class="flex shrink-0 flex-row gap-2">
                    <button
                      type="button"
                      (click)="shareLink()"
                      class="rounded-2xl border border-slate-200 bg-white p-2 text-slate-700 shadow-sm transition hover:shadow disabled:cursor-not-allowed disabled:opacity-50"
                      [disabled]="!canAct()"
                      [attr.aria-label]="t('share')"
                    >
                      <span class="sr-only">{{ t("share") }}</span>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-5 w-5"
                        aria-hidden="true"
                      >
                        <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" />
                        <path d="M16 6l-4-4-4 4" />
                        <path d="M12 2v14" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="copyLink()"
                      class="rounded-2xl border border-slate-200 bg-white p-2 text-slate-700 shadow-sm transition hover:shadow disabled:cursor-not-allowed disabled:opacity-50"
                      [disabled]="!canAct()"
                      [attr.aria-label]="t('copy')"
                    >
                      <span class="sr-only">{{ t("copy") }}</span>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-5 w-5"
                        aria-hidden="true"
                      >
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="toggleQrCode()"
                      class="rounded-2xl border p-2 shadow-sm transition hover:shadow disabled:cursor-not-allowed disabled:opacity-50"
                      [class.border-green-400]="qrCodeVisible()"
                      [class.bg-green-50]="qrCodeVisible()"
                      [class.text-green-700]="qrCodeVisible()"
                      [class.border-slate-200]="!qrCodeVisible()"
                      [class.bg-white]="!qrCodeVisible()"
                      [class.text-slate-700]="!qrCodeVisible()"
                      [disabled]="!canAct()"
                      [attr.aria-label]="t('qrCode')"
                    >
                      <span class="sr-only">{{ t("qrCode") }}</span>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-5 w-5"
                        aria-hidden="true"
                      >
                        <rect x="3" y="3" width="7" height="7" rx="1" />
                        <rect x="14" y="3" width="7" height="7" rx="1" />
                        <rect x="3" y="14" width="7" height="7" rx="1" />
                        <rect x="14" y="14" width="3" height="3" rx="0.5" />
                        <rect x="18" y="14" width="3" height="3" rx="0.5" />
                        <rect x="14" y="18" width="3" height="3" rx="0.5" />
                        <rect x="18" y="18" width="3" height="3" rx="0.5" />
                        <rect x="5" y="5" width="3" height="3" />
                        <rect x="16" y="5" width="3" height="3" />
                        <rect x="5" y="16" width="3" height="3" />
                      </svg>
                    </button>
                  </div>
                </div>
                <p class="mt-3 text-xs font-medium text-green-700" [class.hidden]="!copyToastVisible()">
                  {{ t("copied") }}
                </p>
                @if (qrCodeVisible() && qrCodeDataUrl()) {
                  <div class="mt-3 flex justify-center">
                    <img
                      [src]="qrCodeDataUrl()"
                      [alt]="t('qrCodeAlt')"
                      class="h-40 w-40 rounded-xl border border-slate-200"
                    />
                  </div>
                }
              </div>

              <button
                type="button"
                (click)="shareOnWhatsApp()"
                class="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl bg-[#25D366] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0"
                [disabled]="!canAct()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                {{ t("shareOnWhatsApp") }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </main>

    <footer
      class="border-t border-slate-200 py-6 text-center text-sm text-slate-500 lg:fixed lg:bottom-0 lg:left-0 lg:right-0 lg:border-t lg:bg-white/70 lg:py-3 lg:backdrop-blur"
    >
      <div class="mx-auto flex max-w-4xl flex-col items-center gap-3 px-2">
        <div class="flex flex-col items-center justify-center gap-2 sm:flex-row">
          <span>{{ footerText() }}</span>
          <span class="hidden text-slate-300 sm:inline">•</span>
          <button
            type="button"
            (click)="openPrivacy()"
            class="rounded-xl px-3 py-1 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
          >
            {{ t("privacy") }}
          </button>
        </div>
        <nav
          class="flex flex-wrap justify-center gap-x-3 gap-y-1 text-xs sm:text-sm"
          [attr.aria-label]="t('footerGuidesTitle')"
        >
          <a
            [routerLink]="t('routeComo')"
            class="text-slate-600 underline underline-offset-2 hover:text-green-600"
            >{{ t("linkComo") }}</a>
          <span class="text-slate-300" aria-hidden="true">•</span>
          <a
            [routerLink]="t('routeMensagem')"
            class="text-slate-600 underline underline-offset-2 hover:text-green-600"
            >{{ t("linkMensagem") }}</a>
          <span class="text-slate-300" aria-hidden="true">•</span>
          <a
            [routerLink]="t('routeGerador')"
            class="text-slate-600 underline underline-offset-2 hover:text-green-600"
            >{{ t("linkGerador") }}</a>
        </nav>
      </div>
    </footer>
  </section>
</div>

<dialog
  id="howItWorksDialog"
  (click)="onDialogBackdropClick($event)"
  class="w-[min(92vw,680px)] rounded-3xl bg-white p-0 shadow-2xl ring-1 ring-slate-200 backdrop:bg-slate-900/40"
>
  <div class="p-6 sm:p-8">
    <div class="flex items-start justify-between gap-4">
      <div>
        <p class="text-sm font-medium text-slate-500">{{ t("howItWorks") }}</p>
        <h2 class="mt-1 text-2xl font-semibold tracking-tight">{{ t("modalTitle") }}</h2>
      </div>
      <button
        type="button"
        (click)="closeHowItWorks()"
        class="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium shadow-sm transition hover:shadow"
      >
        {{ t("modalClose") }}
      </button>
    </div>

    <div class="mt-6 space-y-3 text-sm leading-6 text-slate-600">
      <p>- {{ t("modalLine1") }}</p>
      <p>- {{ t("modalLine2") }}</p>
      <p>
        - {{ t("modalLine3a") }}
        <span class="font-mono text-slate-900">https://wa.me/&lt;number&gt;</span>
        {{ t("modalLine3b") }} <span class="font-mono text-slate-900">?text=...</span>.
      </p>
      <p>
        - {{ t("modalLine4") }}
      </p>
    </div>
  </div>
</dialog>

<dialog
  id="privacyDialog"
  (click)="onDialogBackdropClick($event)"
  class="w-[min(92vw,680px)] rounded-3xl bg-white p-0 shadow-2xl ring-1 ring-slate-200 backdrop:bg-slate-900/40"
>
  <div class="p-6 sm:p-8">
    <div class="flex items-start justify-between gap-4">
      <div>
        <p class="text-sm font-medium text-slate-500">{{ t("privacy") }}</p>
        <h2 class="mt-1 text-2xl font-semibold tracking-tight">{{ t("privacyTitle") }}</h2>
      </div>
      <button
        type="button"
        (click)="closePrivacy()"
        class="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium shadow-sm transition hover:shadow"
      >
        {{ t("modalClose") }}
      </button>
    </div>

    <div class="mt-6 space-y-3 text-sm leading-6 text-slate-600">
      <p>- {{ t("privacyLine1") }}</p>
      <p>- {{ t("privacyLine2") }}</p>
      <p>- {{ t("privacyLine3") }}</p>
    </div>
  </div>
</dialog>
